import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export type NbsGroupedBarRow = Record<string, string | number>;

export type NbsGroupedBarChartProps = {
  readonly data: readonly NbsGroupedBarRow[];
  readonly xKey: string;
  readonly seriesKeys: readonly string[];
  readonly height?: number;
  readonly colors?: readonly string[];
};

const DEFAULT_COLORS = ["#000091", "#465fff", "#009081", "#6a6af4", "#e4794a", "#0063cb"];

export function NbsGroupedBarChart({
  data,
  xKey,
  seriesKeys,
  height = 320,
  colors = DEFAULT_COLORS,
}: NbsGroupedBarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={[...data]} margin={{ top: 8, right: 12, left: 0, bottom: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.08)" />
        <XAxis dataKey={xKey} tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip />
        <Legend />
        {seriesKeys.map((key, i) => (
          <Bar key={key} dataKey={key} fill={colors[i % colors.length]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
